import React, { PropTypes } from 'react'

import './ModifyingServiceLoader.scss'
import Backdrop from 'components/Backdrop'
import Loader from 'components/Loader'

const ModifyingServiceLoader = ({ isOpen, ...loaderProps }) => {
  return isOpen &&
    <Backdrop>
      <Loader
        className='ModifyingServiceLoader'
        {...loaderProps}
        />
    </Backdrop>
}

ModifyingServiceLoader.displayName = 'ModifyingServiceLoader'
ModifyingServiceLoader.propTypes = {
  isOpen: PropTypes.bool,
  text: PropTypes.string
}
ModifyingServiceLoader.defaultProps = {
  isOpen: false,
  text: 'Ajustando tu servicio'
}

export default ModifyingServiceLoader



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ModifyingServiceLoader/ModifyingServiceLoader.js